import React, { useState, useEffect } from 'react'
import { authServices } from '../../../_services/Auth/AuthServices'
import toastr from 'toastr'
import { FetchOption } from '../../../_services/CommnService/OptionService/FetchOption'
import LoaderWithLogo from '../../../_components/Loader/LoaderWithLogo'
import { Validation } from '../../../_helpers/validation/Validation'
import { CommonApiService } from '../../../_services/CommnService/CommonApiService'
import DropDown from '../../../_components/_common/DropDown/DropDown'
import { MdDone } from "react-icons/md";
import { AiFillExclamationCircle } from "react-icons/ai";
import MultiLanguageTranslation from '../../../_components/Translate/MultiLangTranslate'

const LoginEnterDetails = (props) => {
  const [mobile, setMobile] = useState("")
  const [type, setType] = useState("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [pan, setPan] = useState("")
  const [aadhaar, setAadhaar] = useState("")
  const [gstNo, setGSTNo] = useState("")
  const [isLoading, setLoader] = useState(false)
  const [error, setError] = useState("")
  const [aadhaarFrontImage, setAadhaarFrontImage] = useState("")
  const [panImage, setPanImage] = useState("")
  const [panverified, setPanverified] = useState(false)
  const [stateArray, setStateArray] = useState([])
  const [state, setStates] = useState("")
  const [cityArray, setCityArray] = useState([])
  const [city, setCity] = useState("")
  const [address, setAddress] = useState("")
  const [pincode, setPincode] = useState("")
  const [aadharverified, setAadhaarverified] = useState(false)
  const [panStateError, setPanStateError] = useState("")
  const [gstNoArr, setGSTNoArr] = useState("")
  const handlePincodeChange=async()=>
  {
    if(pincode.length==6)
    {
    setLoader(true)

      let res=await CommonApiService.getAddressByPincode(pincode)
      
      if(res?.data?.data && res?.data?.status_code==200)
      {
        let e={value:res.data.data.state_id}
        setStates(res.data.data.state_id)
        onchangeState(e)
        setCity(res.data.data.city_id)
      }
      else
      {
        
        setStates("")
        setCity("")
      }
    setLoader(false)

    }
    else
    {
      
      setStates("")
      setCity("")
    }
  }
  useEffect(()=>
  {
    handlePincodeChange()
  },[pincode])
  
  useEffect(() => {
    getState()
    if (props.yourDetails) {
      props.setPANError("")
      setType(props.yourDetails.user_type)
      setPanImage(props.yourDetails.pan_image)
      setAadhaarFrontImage(props.yourDetails.aadhar_front_image)
      setAadhaar(props.yourDetails.aadhar_number)
      if (props.yourDetails.pan_number) {
        setPan(props.yourDetails.pan_number)
        panVerification(props.yourDetails.pan_number)
      } else {
        aadhaarVerification()
      }
    }
  }, [props.yourDetails])

  useEffect(() => {
    if (props.dataForSignUp && Array.isArray(props.dataForSignUp.user_types)) {
      setMobile(props.contact_number)
    }
  }, [props.dataForSignUp])

  const setOptionDataToRedux = async () => {
    var apiresponse = await FetchOption.getByMetaType(null);
    if (apiresponse.data.status_code === 200) {
      props.add(apiresponse.data.data)
    }
    else {
      toastr.error("something went wrong during fetch option data")
    }
  }

  const panVerification = async (p_number) => {
    setLoader(true)
    let dataObj = {
      'action_type': props.isPending?'change':'add',
      "pan": p_number,
      "type": (props.yourDetails.user_type === "FARMERS") ? "I" : "B",
      "email": null,
      "image": null,
      "state": props.yourDetails.state ? props.yourDetails.state : null
    }
    let response = await authServices.panVerification(dataObj)
    if (response && response.data && response.data.data && response.data.data.first_name && response.data.data.success_status !== '0') {
      setName(response.data.data.first_name)
      setPanverified(true)
      if (response && response.data && response.data.data && response.data.data.gstin && response.data.data.gstin[0]) {
        setGSTNo(response.data.data.gstin[0])
        let gstArr = Array.isArray(response.data.data.gstin) ? response.data.data.gstin.map((gst) => gst = { label: gst, value: gst }) : []
        setGSTNoArr(gstArr)
      }
      if (response && response.data && response.data.data && response.data.data.success_status === "2") {
        setPanStateError(response.data.message)
      }
    } else {
      if (response.data.message) {
        props.setPANError(response.data.message)
      }
      props.changeFormType(3)
    }
    setLoader(false)
  }

  const aadhaarVerification = async () => {
    setLoader(true)
    let data = {
      'action_type': props.isPending?'change':'add',
      "aadhar_number": props.yourDetails.aadhar_number,
      "email": null,
      "aadhar_front_image": props.yourDetails.aadhaarFrontImageBase64,
      "aadhar_back_image": props.yourDetails.aadhaarBackImageBase64
    }
    let response = await authServices.aadhaarVerification(data)
    if (response && response.data && response.data.data && response.data.data.aadhar_details && response.data.data.aadhar_details.name && response.data.data.success_status === "1") {
      setName(response.data.data.aadhar_details.name)
      let uid = response.data.data.aadhar_details.uid
      let aadhar_number = props.yourDetails.aadhar_number
      if (uid.substring(uid.length - 4, uid.length) !== aadhar_number.substring(aadhar_number.length - 4, aadhar_number.length)) {
        props.aadhaarError("Aadhaar Number Mismatched!")
        props.changeFormType(3)
      }
      // setAadhaar(response.data.data.aadhar_details.)
      setAadhaarverified(true)
    } else {
      if (response && response.data && response.data.data && response.data.data.aadhar_details && response.data.data.aadhar_details.name === "") {
        props.aadhaarError("Aadhaar Card not Verified!")
        props.changeFormType(3)
      }
      else if (response && response.data && response.data.message) {
        if (response.data && response.data.data && response.data.data.success_status === "2") {
          props.aadhaarError(response.data.message, 2)
        } else {
          props.aadhaarError(response.data.message, 1)
        }
        props.changeFormType(3)
      }
    }
    setLoader(false)
  }

  const getState = async () => {
    await CommonApiService.getStatesOfCountry().then(response => {
      if (response && response.data && response.data.data)
        setStateArray(response.data.data)
    })
  }

  const onchangeState = (e) => {
    setCityArray([])
    setCity("")
    setStates(e.value)
    CommonApiService.getCityOfState(e.value).then(response => {
      if (response && response.data && response.data.data)
        setCityArray(response.data.data)
    })
  }

  const onchangeGSTnumber = (e) => {
    setGSTNo(e.value)
  }

  const onSubmit = async () => {
    let flag = 0
    let data = {
      "name": name,
      "email": email,
      "mobile": mobile,
      "pan_number": pan ? pan : null,
      "aadhar_number": (aadhaar && props.yourDetails.aadhar_front_image !== "") ? aadhaar : null,
      "gstin_number": gstNo ? gstNo : null,
      "gst_billing_state":gstNo &&props.yourDetails.state ? props.yourDetails.state : null,
      "user_type": type,
      "address": address,
      "state": state,
      "district": city,
      "pincode": pincode,
      "pan_image": panImage ? panImage : null,
      "aadhar_front_image": aadhaarFrontImage ? aadhaarFrontImage : null,
      "aadhar_back_image": null
    }

    let obj = Validation(data, rules)
    if (type !== "") {
      if (type === "FARMERS") {
        if (pan === "" && aadhaar === "") {
          obj.aadhar_number = "PAN/Aadhaar Number is Required!";
          toastr.info("Aadhaar Number or PAN Number, any one is Required!")
        }
      } else {
        if (pan === "" && gstNo === "") {
          obj.pan_number = pan === "" ? "PAN Number is Required!" : obj.pan_number;
          obj.gstin_number = gstNo === "" ? "GST Number is Required!" : obj.gstin_number;
        }
      }
    }

    setError(obj)
    Object.keys(obj).forEach(index => {
      if (obj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      setLoader(true)
      //  let result = await authServices.register(data)
      let result = await authServices.registerUpdateKyc(data)
      if (result !== null && result !== undefined && result.data && typeof (result.data.data) === 'object' && result.data.data.success_status !== "0") {
        if (result && result.data && result.data.message) {
          toastr.info(result.data.message)
        }
        if (result.data.data.success_status === "1" && result.data.data.token) {
          localStorage.setItem("authToken", result.data.data.token);
          localStorage.setItem("userDashBoardData", JSON.stringify(result.data.data));
          localStorage.setItem("notifications", JSON.stringify(result.data.data));
          localStorage.setItem("userDashBoardDataplan", JSON.stringify(result.data.data.userPlan));
          
          localStorage.setItem('disbrusementPopup', result.data.data.disbursementPopUp)
          if(result?.data?.data?.role_name  && result.data.data?.member?.roles[0].name === result.data.data.role_name){
            localStorage.setItem("isOtherUser","isOtherUser");
          }
          localStorage.setItem("aryauserType", result.data.data.member.roles[0].id);
          localStorage.setItem("isKyc", result.data.data.member.kyc);
          localStorage.setItem("isParent", result.data.data.member.parent_id);
          localStorage.setItem("user_type", result.data.data.user_type);

          localStorage.setItem("rms_expire", result.data.data.rms_expire);
          localStorage.setItem("rms_token", result.data.data.rms_token);
          localStorage.setItem("rms_user", result.data.data.rms_user);
          
          
          setOptionDataToRedux();
          props.clearCartCount();
          props.clearCompare();
          props.addCompareParameter(result.data.data.member.comparison_parameters);
          props.addCartCount(result.data.data.cart);
          props.changeFormType(1)
          props.close()
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      } else if (result && result.data && result.data.message) {
        if (result.data.message.split(' ').includes('Email')) {
          let err = {
            email: result.data.message
          }
          setError(err)
        }
        //  else if (result.data.message.split(' ').includes('PAN')) {
        //   setPanStateError(result.data.message)
        //   props.changeFormType(3)
        // } 
        else {
          toastr.info(result.data.message)
        }
      }
      setLoader(false)
    }
  }

  const onKeyPressSubmit = (e) => {
    if (e.key === 'Enter')
      onSubmit()
  }

  return <div className="filterbx p-0">
    <LoaderWithLogo isLoading={isLoading}></LoaderWithLogo>
    <div className="newpoBX">
      <div style={{ fontSize: '13px', color: '#0587ea', fontWeight: 500 }}>{panStateError && "Note: " + panStateError}</div>
      <div className="form-group mt-2 pologin">
        <label className="polabel"><MultiLanguageTranslation title="Your full name as per Aadhaar" />/ {type === "FARMERS" ? "" : 'Business'} <MultiLanguageTranslation title="PAN card" /></label>
        <input
          name="first_name"
          type="text"
          className="form-control poinput"
          id=""
          placeholder="Name"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyPress={onKeyPressSubmit}
          readOnly={true}
        />
        {(panverified || aadharverified) && <MdDone color="green" size="20" style={{ float: "right", position: 'relative', top: '-26px', right: '12px' }} />}
        {error && error.name !== "" && (
          <div className="fromerror">{error.name}</div>)}
      </div>

      {type === "FARMERS" && aadhaar && <div className="form-group pologin">
        <label className="polabel"><MultiLanguageTranslation title="Your Aadhaar Number" /></label>
        <input
          name="first_name"
          type="text"
          className="form-control poinput"
          id=""
          onChange={e => setAadhaar(e.target.value)}
          placeholder="Aadhaar Number"
          value={aadhaar}
          readOnly={true}
          onKeyPress={onKeyPressSubmit}
        />
        {aadharverified && <MdDone color="green" size="20" style={{ float: "right", position: 'relative', top: '-26px', right: '12px' }} />}
        {error && error.aadhar_number !== "" && (
          <div className="fromerror">{error.aadhar_number}</div>)}
      </div>}

      {pan && <div className="form-group pologin mt-4">
        <label className="polabel"> {type === "FARMERS" ? "" : "Business"} <MultiLanguageTranslation title="Your PAN Card Details" /></label>
        <input
          name="first_name"
          type="text"
          className="form-control poinput"
          id=""
          placeholder="PAN Number"
          onChange={e => setPan(e.target.value)}
          value={pan}
          readOnly={true}
          onKeyPress={onKeyPressSubmit}
        />
        {panverified && <MdDone color="green" size="20" style={{ float: "right", position: 'relative', top: '-26px', right: '12px' }} />}
        {error && error.pan_number !== "" && (
          <div className="fromerror">{error.pan_number}</div>)}
      </div>}

      {gstNoArr && <div className="form-group mt-2 pologin twofield">
        <div className={error && error.gstin_number && error.gstin_number !== "" ? "polabel-err" : "polabel"}>Select GST Number</div>
        {<DropDown onKeyPress={onKeyPressSubmit} preselected={gstNo} options={gstNoArr} onChange={onchangeGSTnumber} className={error && error.gstin_number && error.gstin_number !== "" ? "polabelError" : ""} />}
        {error && error.state !== "" && (
          <div className="fromerror">{error.gstin_number}</div>)}
      </div>}

      {/* {gstNo && <div className="form-group pologin">
        <label className="polabel"><MultiLanguageTranslation title="Your GST Number" /></label>
        <input
          name="first_name"
          type="text"
          className="form-control poinput"
          placeholder="GST Number"
          value={gstNo}
          readOnly={true}
          onKeyPress={onKeyPressSubmit}
        />
        {gstNo && <MdDone color="green" size="20" style={{ float: "right", position: 'relative', top: '-26px', right: '12px' }} />}
        {error && error.gstin_number !== "" && (
          <div className="fromerror">{error.gstin_number}</div>)}
      </div>} */}

      <div className="form-group mt-4">
        <div className="poxlogin">
          <input name="first_name"
            type="text"
            className="poxinput"
            id=""
            // placeholder="Enter Email "
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyPress={onKeyPressSubmit}
            required
          />
          <label className="poxlabel">Your Email Address</label>
          {error && error.email !== "" && (
            <div className="fromerror">{error.email}</div>)}
        </div>
      </div>

      <div className="form-group mt-4">
        <div className="poxlogin">
          <textarea name="first_name"
            style={{ minHeight: '87px' }}
            type="textarea"
            className={error && error.address && error.address !== "" ? "poxinput-error" : "poxinput"}
            id=""
            // placeholder="Enter Village/Town Area"
            value={address}
            onChange={e => setAddress(e.target.value)}
            required
            onKeyPress={onKeyPressSubmit}
          />
          {error && error.address && error.address !== "" && <AiFillExclamationCircle size={25} className="poxinput-excl"></AiFillExclamationCircle>}
          <label className={error && error.address && error.address !== "" ? "poxlabel-error" : "poxlabel"}>Communication Address</label>
          {error && error.address !== "" && (
            <div className="fromerror">{error.address}</div>)}
        </div>
      </div>

      <div className="form-group mt-4">
        <div className="poxlogin">
          <input name="first_name"
            type="text"
            className={error && error.pincode && error.pincode !== "" ? "poxinput-error" : "poxinput"}
            id=""
            // placeholder="Pincode"
            value={pincode}
            onChange={e => setPincode(e.target.value)}
            onKeyPress={onKeyPressSubmit}
            required
          />
          {error && error.pincode && error.pincode !== "" && <AiFillExclamationCircle size={25} className="poxinput-excl"></AiFillExclamationCircle>}
          <label className={error && error.pincode && error.pincode !== "" ? "poxlabel-error" : "poxlabel"}>Pincode</label>
          {error && error.pincode !== "" && (
            <div className="fromerror">{error.pincode}</div>)}
        </div>
      </div>

      <div className="sta-dis">
        {<div className="form-group mt-2 pologin twofield">
          <div className={error && error.state && error.state !== "" ? "polabel-err" : "polabel"}>State</div>
          {/* (panImage || ) ? */}
          {stateArray && <DropDown onKeyPress={onKeyPressSubmit} preselected={state} options={stateArray} onChange={onchangeState} className={error && error.state && error.state !== "" ? "polabelError" : ""} />}

          {error && error.state !== "" && (
            <div className="fromerror">{error.state}</div>)}

        </div>}

        <div className="form-group mt-2 pologin twofield">
          <div className={error && error.district && error.district !== "" ? "polabel-err" : "polabel"}>District</div>
          {cityArray && <DropDown onKeyPress={onKeyPressSubmit} preselected={city} options={cityArray} onChange={(e) => setCity(e.value)} className={error && error.district && error.district !== "" ? "polabelError" : ""} />}

          {error && error.district !== "" && (
            <div className="fromerror">{error.district}</div>)}
        </div>

      </div>
    </div>
    <div className="mt-2">
      <a  className="form-control posubmit" onClick={() => onSubmit()} style={{ backgroundColor: "#e08701", textAlign: 'center', color: "#fff", fontWeight: '600', cursor: 'pointer' }}>Submit</a>
    </div>
  </div>
}
export default LoginEnterDetails

const rules = [{
  field_name: 'user_type',
  label: 'User Type',
  type: "string",
  isRequired: true
},
{
  field_name: 'name',
  label: 'Name',
  type: "string",
  isRequired: true
},
{
  field_name: 'email',
  label: 'Email',
  type: "email",
  isRequired: false
},
{
  field_name: 'pan_number',
  label: 'PAN Number',
  type: "pan",
  isRequired: false
},
{
  field_name: 'aadhar_number',
  label: 'Aadhaar Number',
  type: "number",
  min: 12,
  max: 12,
  isRequired: false
},
{
  field_name: 'pincode',
  label: 'Pincode',
  type: "number",
  min: 6,
  max: 6,
  isRequired: true
},
{
  field_name: 'district',
  label: 'District',
  type: "string",
  isRequired: true
},
{
  field_name: 'state',
  label: 'State',
  type: "string",
  isRequired: true
},
{
  field_name: 'address',
  label: 'Communication Address',
  type: "string",
  isRequired: true
},
]
